import { TrimEditableImage } from '../trim.editable-image';
import { TrimPrintManager, TrimPrint } from '../../../print/trim.print';
import { TrimEditableImageManager } from '../../editable-image/trim.editable-image.manager';
import { TrimPanZoomManager } from '../../pan-zoom/trim.pan-zoom.manager';
import { TrimFrameController } from '../frame/trim.frame-controller';
import { TrimImageEvent } from './trim.image-event';
import { TrimImageEditableTool } from './trim.image-editable-tool';
import * as lodash from 'lodash';
import { cloneDeep } from 'lodash';
import { TrimDataManager } from '../../data/trim-data.manager';
import * as createjs from 'createjs-module';
import { TrimCjBitmap, TrimCjContainer, TrimCjShape } from '../../../model/cj-factory';
import { TrimCjTool } from '../../../../utilities/trim.cj-tool';
import { CJ_CONTAINER_NAME, CJ_DPOBJ_NAME } from '../../../model/cj-factory/trim.cj-obj-name.collection';
import { TrimUiManager } from '../../ui/trim.ui.manager';
import { TrimEditableEvent } from '../trim.editable-event';
import { TrimImageEditManager } from '../trim.image-edit.manager';
import { store } from '../../../../app/store';
import { apiActions } from '../../../../slices/api-slice';
import { ApiImagesGetOne, ImagesGetResponse } from '../../../../api/front/images/api-images';
import { OrderPageDataXml } from '../../../../xml/class/order/order-page-data-xml';
import { TrimEditableSideTool } from '../trim.editable-side-tool';
import { FitChecker } from '../../../../utilities/fit-checker';
import { XmlStructureOrderInfoData } from '../../../../xml/model/xml-structure-model';
import {
  POSTCARD_ID,
  PostCardType,
  RIGHT_ROTATE_LIST,
} from '../../../../components/pages/layout/select-template/layout.select-template';
import PixelConverter, { WH } from '../../../../utilities/pixel-converter';
import { UiManager } from '../../../../layout-editor/manager/ui/ui.manager';
import { EditableImageManager } from '../../../../layout-editor/manager/editable-image/editable-image.manager';
import { IMAGES_KIND } from '../../../../layout-editor/manager/image-processor/image-processor.manager';
import { ApiPrintImagesGet } from '../../../../api/sift/front/api-print-image';

export const initPictureFlags = {
  isRotate: false,
  isRestore: false,
  isClone: false,
  isPostCard: false,
  isUpdate: false,
  isExchange: false,
  isExchangeOne: false,
  isDirectTemp: false,
  postCardType: undefined,
  dropTemp: false,
  isChangeCover: false,
};

export type PictureFlagParams = {
  isRotate: boolean,
  isRestore: boolean,
  isClone: boolean,
  isUpdate: boolean,
  isExchange: boolean,
  isExchangeOne: boolean,
  isDirectTemp: boolean,
  postCardType: PostCardType,
  dropTemp: boolean,
  isChangeCover: boolean,
}

type UsedImageListType = {
  path: string;
  name: string;
}

export class TrimImageController {
  public fitNum = 5;
  public imageSetMode: 'in' | 'out' | 'eq' = 'out';
  public images: TrimEditableImage[] = [];
  public orderPage?: OrderPageDataXml;
  public orderInfo?: XmlStructureOrderInfoData;
  public static saveBlob: { blob: Blob, url: string } | null = null;

  private stage: TrimCjContainer;
  private readonly pageId: string;

  private printManager!: TrimPrintManager;
  private editableImageManager!: TrimEditableImageManager;
  private panZoomManager!: TrimPanZoomManager;
  private frameController!: TrimFrameController;
  private imageEvent!: TrimImageEvent;
  private imageEditableTool!: TrimImageEditableTool;
  private trimDataManager!: TrimDataManager;
  private editableEvent!: TrimEditableEvent;
  private editableSideTool!: TrimEditableSideTool;
  private imageEditManager!: TrimImageEditManager;

  constructor(stage: TrimCjContainer, pageId: string) {
    this.stage = stage;
    this.pageId = pageId;
  }

  initialize(): void {
  }

  destroy(): void {
    this.images = [];
  }

  update(stage: TrimCjContainer): void {
    this.stage = stage;
  }

  di(
    frameController: TrimFrameController,
    printMng: TrimPrintManager,
    editableMng: TrimEditableImageManager,
    panZoomMng: TrimPanZoomManager,
    imageEvent: TrimImageEvent,
    imageEditableTool: TrimImageEditableTool,
    layoutDataManager: TrimDataManager,
    editableEvent: TrimEditableEvent,
    editableSideTool: TrimEditableSideTool,
    imageEditMng: TrimImageEditManager,
  ): void {
    this.frameController = frameController;
    this.printManager = printMng;
    this.editableImageManager = editableMng;
    this.panZoomManager = panZoomMng;
    this.imageEvent = imageEvent;
    this.imageEditableTool = imageEditableTool;
    this.trimDataManager = layoutDataManager;
    this.editableEvent = editableEvent;
    this.editableSideTool = editableSideTool;
    this.imageEditManager = imageEditMng;
  }

  // Imageの作成
  static async createImageAsync(src: string, targetFile: string, name: string, zip: {
    isZip: boolean,
    level: number
  } | undefined, _blob?: Blob, isExChange?: boolean): Promise<TrimCjContainer> {
    return new Promise((resolve) => {
      if (!zip?.isZip) {
        fetch(
          `${src}/${targetFile}`,
          { method: 'GET', mode: 'cors' },
        ).then((res) => {
          res.blob().then((v) => {
            const url = window.URL.createObjectURL(v);
            const image = new TrimCjBitmap(url);
            setTimeout(() => {
              URL.revokeObjectURL(url);
            });
            image.name = name;
            const imageContainer = new TrimCjContainer();
            imageContainer.name = `${name}-container`;
            imageContainer.addChild(image);
            resolve(imageContainer);
          });
        });
      } else {
        let srcPath = src;
        if (src.indexOf('___') !== -1 && zip.level > 0) {
          srcPath = src.substring(0, src.indexOf('___'));
        }
        const xmlUrlArr = srcPath.split('/');
        const urlPath = zip.level === 0
          ? srcPath
          : zip.level === 1
            ? xmlUrlArr.filter((v, i) => i < xmlUrlArr.length - 1).join('/')
            : xmlUrlArr.filter((v, i) => i < xmlUrlArr.length - 2).join('/');
        if (_blob && (!this.saveBlob || (this.saveBlob?.url !== `${urlPath + '/template.zip'}`)) && !isExChange) this.saveBlob = {
          url: `${urlPath + '/template.zip'}`,
          blob: _blob,
        };
        if (this.saveBlob && this.saveBlob?.url === `${urlPath + '/template.zip'}`) {
          const tempNameArr = xmlUrlArr[xmlUrlArr.length - 1].split('_');
          const typeName = tempNameArr[tempNameArr.length - 1].match(/^[A-Z]+/);
          const searchName = `${typeName?.[0]}/${xmlUrlArr[xmlUrlArr.length - 1]}`;
          TrimUiManager.ins.emit('t->r:zip-file:get', {
            file: this.saveBlob.blob,
            path: zip.level === 0 ? targetFile : `${searchName}/${targetFile}`,
            callback: (vvv) => {
              const url = window.URL.createObjectURL(vvv.file);
              const image = new TrimCjBitmap(url);
              setTimeout(() => {
                URL.revokeObjectURL(url);
              });
              image.name = name;
              const imageContainer = new TrimCjContainer();
              imageContainer.name = `${name}-container`;
              imageContainer.addChild(image);
              resolve(imageContainer);
            },
            id: `${urlPath + '/template.zip'}`,
          });

        } else {
          fetch(urlPath + '/template.zip', { method: 'GET', mode: 'cors' })
            .then(async (v) => {
              const blob = await v.blob();
              this.saveBlob = {
                url: `${urlPath + '/template.zip'}`,
                blob: blob,
              };
              const tempNameArr = xmlUrlArr[xmlUrlArr.length - 1].split('_');
              const typeName = tempNameArr[tempNameArr.length - 1].match(/^[A-Z]+/);
              const searchName = `${typeName?.[0]}/${xmlUrlArr[xmlUrlArr.length - 1]}`;
              TrimUiManager.ins.emit('t->r:zip-file:get', {
                file: blob,
                path: zip.level === 0 ? targetFile : `${searchName}/${targetFile}`,
                callback: (vvv) => {
                  const url = window.URL.createObjectURL(vvv.file);
                  const image = new TrimCjBitmap(url);
                  setTimeout(() => {
                    URL.revokeObjectURL(url);
                  });
                  image.name = name;
                  const imageContainer = new TrimCjContainer();
                  imageContainer.name = `${name}-container`;
                  imageContainer.addChild(image);
                  resolve(imageContainer);
                },
                id: `${urlPath + '/template.zip'}`,
              });
            });
        }
      }
    });
  }

  // -- 画像のマスクを再設定する(直接操作しない処理で利用(Redo・Undoなど)) --
  static updateImageView(image: TrimCjContainer) {
    const target = TrimCjTool.getImageContainer(image);
    target.filters = [];
    target.uncache();
    // const mask = CjTool.getMaskContainer(target);
    const _mask = TrimCjTool.getMaskContainer(target);
    const mask = _mask.getChildByName('mask').clone();
    const maskData = _mask.getBounds();
    mask.set({ alpha: 0, x: 0, y: 0 });
    mask.cache(0, 0, maskData.width, maskData.height);
    target.filters = [new createjs.AlphaMaskFilter(mask.cacheCanvas as HTMLCanvasElement)];
    target.cache(0, 0, maskData.width, maskData.height);
  }

  // - 写真の生成 -
  async createPhotoImage(editableImage: TrimEditableImage, target: TrimCjContainer, isReset?: boolean, isPng?: boolean) {
    if (!editableImage) return;


    const imageArea = TrimCjTool.getImageAreaContainer(target);
    const scaleContainer = TrimCjTool.getScaleContainer(target);

    // -- 参照切り --
    const photoImage = lodash.cloneDeep(editableImage.editable);
    // -- ハイライトを透明に戻す --
    const highlight = TrimCjTool.getHighlight(target);
    if (highlight) highlight.visible = false;
    // -- マスクを作成 --
    const container = TrimCjTool.getRotateContainer(target);

    const maskContainer = TrimCjTool.getMaskContainer(target);
    const mask = maskContainer.getChildByName('mask').clone();
    mask.set({ alpha: 0, x: 0, y: 0 });
    // -- コンテナ用意 --
    const imageContainer = new TrimCjContainer();
    const photoContainer = new TrimCjContainer();
    // -- RealRect設置 --
    imageContainer.addChild(photoContainer);
    photoContainer.addChild(photoImage);
    // -- 境界情報を取得 --
    const _frameData = await TrimCjTool.checkLoad(maskContainer);
    const frameData = _frameData.getTransformedBounds();

    // -- マスク情報 --
    const _maskData = await TrimCjTool.checkLoad(mask);
    const maskData = _maskData.getBounds();
    const maskH = maskData.height;
    const maskW = maskData.width;
    // -- リサイズ（写真フィット機能込み） --
    const scale = await this.resizeImage(imageArea, photoImage, maskH, maskW);
    const containerData = imageContainer.getTransformedBounds();
    // -- 画像情報 --
    const photoH = containerData.height;
    const photoW = containerData.width;
    const scaleY = scale;
    const scaleX = scale;
    // -- 回転対応用に変数用意 --
    const _maskH = maskH;
    const _maskW = maskW;

    const y = await this.centeringImage(photoH, _maskH, scaleY);
    const x = await this.centeringImage(photoW, _maskW, scaleX);
    imageContainer.set({
      pageId: this.pageId,
      photoAreaId: editableImage.photoAreaId,
      editableImageId: editableImage.id,
      name: CJ_CONTAINER_NAME.image,
      x: maskContainer.x * 2,
      y: maskContainer.y * 2,
      regX: maskContainer.x,
      regY: maskContainer.y,
    });
    photoImage.set({
      // x: -x,
      // y: -y,
      name: CJ_DPOBJ_NAME.image,
    });

    const photoData = photoContainer.getTransformedBounds();
    const printTrimData = this.printManager.printTrimData;
    const imageSize: WH = {width: Number(editableImage.virtualWidth) * scale, height: Number(editableImage.virtualHeight) * scale};
    // const imageMovePos =  {x: 0, y: 0};

    photoContainer.set({
      pageId: this.pageId,
      photoAreaId: editableImage.photoAreaId,
      editableImageId: editableImage.id,
      copyFlag: false,
      deleteFlag: false,
      setMode: this.imageEditManager.printMenu.modeInOut,
      real: {
        x: (imageArea.virtual?.x! - x) * (this.imageEditManager.templateReal.w / this.imageEditManager.templateVirtual.w),
        y: (imageArea.virtual?.y! - y) * (this.imageEditManager.templateReal.w / this.imageEditManager.templateVirtual.w),
        width: Number(editableImage.virtualWidth) * scale * (this.imageEditManager.templateReal.w / this.imageEditManager.templateVirtual.w),
        height: Number(editableImage.virtualHeight) * scale * (this.imageEditManager.templateReal.w / this.imageEditManager.templateVirtual.w),
      },
      virtual: {
        x: imageArea.virtual?.x! - x,
        y: imageArea.virtual?.y! - y,
        width: Number(editableImage.virtualWidth) * scale,
        height: Number(editableImage.virtualHeight) * scale,
      },
      selectImageSize: {
        width: editableImage.realWidth,
        height: editableImage.realHeight,
      },
      // 写真に連番？
      photoSeqNo: 0,
      // orderSelect.xmlから取得
      realPath: editableImage.path,
      selectID: editableImage.selectId,
      name: CJ_CONTAINER_NAME.photo,
      x: (photoData.width / 2) * scale - x,
      y: (photoData.height / 2) * scale - y,
      regX: (photoData.width / 2),
      regY: (photoData.height / 2),
      differPos: {
        x: 0,
        y: 0,
      },
    });

    photoContainer.originalBounds.width = cloneDeep(photoData.width);
    photoContainer.originalBounds.height = cloneDeep(photoData.height);
    photoContainer.originalBounds.x = cloneDeep(photoContainer.x);
    photoContainer.originalBounds.y = cloneDeep(photoContainer.y);
    photoContainer.defaultPos.x = cloneDeep(photoContainer.x);
    photoContainer.defaultPos.y = cloneDeep(photoContainer.y);
    photoContainer.defaultMovePos.x = -x;
    photoContainer.defaultMovePos.y = -y;
    photoContainer.scaleY = scale;
    photoContainer.scaleX = scale;
    photoContainer.defaultScale = scale;

    if (!isReset) {
      const base = printTrimData?.temp.base;
      const _scale = printTrimData?.view.image.scale || scale;
      // const _scale = printTrimData?.getImageScale({width: Number(editableImage.virtualWidth), height: Number(editableImage.virtualHeight)}) || scale;
      // photoContainer.scaleY = _scale;
      // photoContainer.scaleX = _scale;
      const tempSize: WH = {width: PixelConverter.mmToPx(base?.width ?? photoData.width), height: PixelConverter.mmToPx(base?.height ?? photoData.height)};
      // const imageMovePos = printTrimData?.getImageMovePos(
      //   { width: Number(editableImage.virtualWidth), height: Number(editableImage.virtualHeight) },
      //   tempSize,
      //   scale
      // ) ?? {x: 0, y: 0};
      const imageMovePos = printTrimData?.view.image.pos ?? {x: 0, y: 0};
      photoContainer.set({
        real: {
          x: (imageArea.virtual?.x! - x - (imageMovePos.x - x)) * (this.imageEditManager.templateReal.w / this.imageEditManager.templateVirtual.w),
          y: (imageArea.virtual?.y! - y - (imageMovePos.y - y)) * (this.imageEditManager.templateReal.w / this.imageEditManager.templateVirtual.w),
          width: Number(editableImage.virtualWidth) * _scale * (this.imageEditManager.templateReal.w / this.imageEditManager.templateVirtual.w),
          height: Number(editableImage.virtualHeight) * _scale * (this.imageEditManager.templateReal.w / this.imageEditManager.templateVirtual.w),
        },
        virtual: {
          x: imageArea.virtual?.x! - x - (imageMovePos.x - x),
          y: imageArea.virtual?.y! - y - (imageMovePos.y - y),
          width: Number(editableImage.virtualWidth) * _scale,
          height: Number(editableImage.virtualHeight) * _scale,
        },
      });
      photoContainer.x -= imageMovePos.x;
      photoContainer.y -= imageMovePos.y;
      photoContainer.scaleX = _scale;
      photoContainer.scaleY = _scale;
      photoContainer.rotation = printTrimData?.view.image.rotate ?? 0;
    }

    // -- チェッカーの生成 --
    const checker = new TrimCjShape();
    checker.graphics.f('red').dr(0, 0, photoData.width, photoData.height);
    checker.set({
      name: CJ_DPOBJ_NAME.checker,
      alpha: 0,
      mouseEnabled: false,
    });
    photoContainer.addChild(checker);

    // -- 画像の追加 --
    this.imageEvent.setImageEvent(photoContainer, 'image');
    imageContainer.mouseEnabled = false;
    container.addChild(imageContainer);
    imageArea.isComposited = true;
    const containerLength = container.numChildren;
    imageArea && container.setChildIndex(imageArea, containerLength - 1);
    const isToast = FitChecker.checkImageOneOutBounds(photoContainer);
    this.imageEditManager.isFit = isToast;
    TrimUiManager.ins.emit('t->r:show-toast', { isToast, target });
    // -- マスクの反映処理 --
    // console.log(maskContainer);
    maskContainer.alpha = 0;
    mask.cache(0, 0, frameData.width, frameData.height);
    imageContainer.filters = [new createjs.AlphaMaskFilter(mask.cacheCanvas as HTMLCanvasElement)];
    imageContainer.cache(0, 0, frameData.width, frameData.height);
    // const bgImg = this.stage.getChildByName(CJ_CONTAINER_NAME.base)
    // console.log(this.stage);
    // bgImg.alpha = 0;
    // imageContainer.alpha = 0;
  }

  // - 画像を中心に配置する -
  async centeringImage(imageSize: number, maskSize: number, imageScale: number) {
    if (!maskSize || imageSize * imageScale === maskSize) return 0;
    // return (imageSize - maskSize) / 2;
    return (imageSize * imageScale - maskSize) / 2;
  }

  // - 初期サイズの変更 -
  async resizeImage(imageArea: TrimCjContainer, image: TrimCjBitmap | TrimCjContainer, minHeight: number, minWidth: number) {
    // -- フレームへの収まり具合で処理を分岐 --
    if (!minHeight || !minWidth) return 0;
    const imageData = image.getBounds();
    // const fitNum = 0;
    const fitNum = this.fitNum * 2;
    let scaleX = (minWidth + fitNum) * image.scaleX / imageData.width!;
    let scaleY = (minHeight + fitNum) * image.scaleY / imageData.height!;
    scaleX = Math.round(scaleX * 100) / 100;
    scaleY = Math.round(scaleY * 100) / 100;
    switch (this.imageEditManager.printMenu.modeInOut) {
      case 'in':
        return (scaleY < scaleX ? scaleY : scaleX);
      case 'out':
        return (scaleY > scaleX ? scaleY : scaleX);
      case 'eq':
        const editableImg = this.printManager.editableImage;
        if (editableImg) {
          const scale = Number(editableImg.originalWidth) / Number(editableImg.virtualWidth) / TrimDataManager.getAdditionalValue;
          return Math.round(scale * 100) / 100;
        }
        return 1;
    }

  }

  async restore() {
    // if (this.albumManager.currentAlbum?.restoreMount) {
    //   const xml = store.getState().xml[this.imageEditManager.shopOrderId];
    //   const orderInfo = xml?.orderInfo?.infoData?.find((info) => info.xml.metaModel.id === this.imageEditManager.orderId);
    //   const orderParts = orderInfo?.parts?.partsData;
    //   const orderPages = orderParts?.map((elm) => elm.print?.pageData).flat();
    //   const currentAlbumPath = this.albumManager.currentAlbum?.indexes;
    //   const orderPage = orderPages?.find((print) => isEqual(print?._indexes, currentAlbumPath));
    //   this.orderPage = orderPage;
    // }
    await this.restorePhoto();
    // await this.restorePNG();
    // await this.restoreLogo();
    this.stage.stage.update();
  }

  async getImage(v: any) {
    return new Promise<any>((resolve) => {
      const path = `${this.imageEditManager.kijshopCd}/${this.imageEditManager.shopOrderId}/FreeGraphics/${v.selectFileName?.real.path}`;
      store.dispatch(apiActions.run(
        new ApiImagesGetOne({
          kijshopCd: this.imageEditManager.kijshopCd,
          path,
        }),
        {
          onSuccess: (blob: Blob) => {
            const name = v.originalFileName.real.path ?? '';
            const file = new File(
              [blob],
              name,
              {
                lastModified: new Date().getTime(),
                type: blob.type,
              },
            );
            resolve({ file, selectID: v.selectID ?? '', path, image: v });
          },
        },
      ));
    });
  };

  private getImageOne (data: UsedImageListType, isLogo?: boolean, fileName?: string) {
    // 0299999/0299999001032/FreeGraphics/20220512014214.png
    return new Promise<{file: File, path: string, hashFile: File}>((resolve) => {
      const kijshopCd = this.imageEditManager.kijshopCd;
      const path = `${data.path}/${data.name}`;
      store.dispatch(apiActions.run(
        new ApiImagesGetOne({
          kijshopCd,
          path,
        }),
        {
          onSuccess: (blob: Blob) => {
            if (blob.type === 'application/json') {
              resolve({ file: new File([], ''), path: '', hashFile: new File([], '')});
              return;
            }
            const file = new File(
              [blob],
              fileName ?? data.name,
              {
                lastModified: new Date().getTime(),
                type: blob.type,
              },
            );
            const hashFile = new File(
              [blob],
              'dummy_hash.jpg',
              {
                lastModified: new Date().getTime(),
                type: blob.type,
              },
            );
            resolve({ file, path: data.path, hashFile });
          },
          onError: (e) => {
            resolve({ file: new File([], ''), path: '', hashFile: new File([], '')});
          },
        },
      ));
    });
  };

  async restorePNG() {
    return new Promise<void>(async (resolve) => {
      const printTrimData = this.printManager.printTrimData;
      const kijshopCd = this.imageEditManager.kijshopCd;
      const shopOrderId = this.imageEditManager.shopOrderId;
      const orderId = this.imageEditManager.orderId;
      if (!printTrimData) return;
      const pngList = await new Promise<ImagesGetResponse[]>((resolve) => {
        store.dispatch(apiActions.run(
          new ApiPrintImagesGet({
            kijshopCd,
            shopOrderId,
            kind: IMAGES_KIND.FREE_GRAPHICS,
          }),
          {
            onSuccess: (v: any) => {
              resolve(v.body.data?.fileList ?? []);
            },
            onError: () => resolve([]),
          }
        ))
      });
      for (const stamp of printTrimData.stamps) {
        const target = pngList.find(png => png.filename === stamp.fileName);
        if (!target) continue;
        const imageFile = await this.getImageOne({path: target.path, name: target.filename})
        TrimUiManager.ins.emit('r->t:add-image-png', {
          files: [imageFile.file],
          kijshopCd,
          shopOrderId,
          orderId,
          restore: true,
          path: imageFile.path,
          onCreatedEditableImage: (e) => {
            this.editableSideTool.addImage(e.editableImage, true);
          },
        });
        console.log(this.editableImageManager.list);
      }
      resolve();
    });
  }

  private async restorePhoto() {
    const orderPicture = this.orderPage?.viewModel.orderPicture;
    if (orderPicture) {
      orderPicture.data = orderPicture.data?.filter((v) => v.deleteFlag !== '1');
    }
    const targetFrame = this.trimDataManager.getEditor();
    for (const picture of orderPicture?.data ?? []) {
      const targetPic = this.editableImageManager.list.filter(TrimEditableImageManager.filterShopOrder(
        this.imageEditManager.kijshopCd,
        this.imageEditManager.shopOrderId,
      )).find((editableImage) => (editableImage.selectId === picture.selectID) && (editableImage.kind === '6'));
      if (targetPic) {
        targetPic.photoAreaId = picture.subMaskID || '';
        if (targetFrame) {
          // await this.createPhotoImage(targetPic, targetFrame, { ...initPictureFlags, isRestore: true });
        }
        const container: TrimCjContainer = this.trimDataManager.getImageArea();
        let count = 0;
        const isPhoto = TrimCjTool.checkPhotoInFrame(container);
        if (isPhoto) {
          count++;
        }
        const album: TrimPrint = this.trimDataManager.getCurrentPrint();
        TrimUiManager.ins.emit('t->r:count-photo', { album, photoCount: count });
      }
    }
  }

  private duplicateWarningPhoto = (): Promise<boolean> => new Promise((resolve) => {
    TrimUiManager.ins.emit('t->r:push-dialog', {
      title: '確認',
      message: [
        '同一のファイルがすでに使用されています。',
        'このまま同一の画像ファイルを配置してもよい場合は「はい」、中止する場合は「いいえ」をクリックしてください。',
      ],
      buttons: [
        { label: 'いいえ', callback: () => resolve(false) },
        { label: 'はい', callback: () => resolve(true) },
      ],
    });
  });

  private async getRealRect(editableImage: TrimEditableImage) {
    return new Promise<undefined | { realHeight?: string, realWidth?: string }>((resolve) => {
      this.editableImageManager.getRealSize(editableImage.id)
        .then((v) => {
          resolve(v);
        })
        .catch((e) => {
          TrimUiManager.ins.emit('t->r:push-dialog', {
            title: '確認',
            message: [`${e}`],
            buttons: [
              {
                label: 'OK', callback: () => {
                },
              },
            ],
          });
          resolve(undefined);
        });
    });
  }

}
